<script type="text/ecmascript-6">
    import DesignerQuestionHardwareLetterbox from "./DesignerQuestionHardwareLetterbox.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareLetterbox,
            SynsealQuestion,
        ],
        computed: {
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            }
        }
    }
</script>
